import { resolveGuildEmblem } from '../../constants/guildEmblems';
import i18n from '../../i18n';
import { translateApiMessages } from '../../utils/apiMessages';
import { apiErrorFromResponse } from '../../utils/apiErrors';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5200/api';

export function getApiBaseUrl() {
  return API_BASE_URL;
}

export function getFullImageUrl(relativeOrAbsoluteUrl) {
  if (!relativeOrAbsoluteUrl) return null;
  relativeOrAbsoluteUrl = resolveGuildEmblem(relativeOrAbsoluteUrl);
  if (relativeOrAbsoluteUrl.startsWith('http://') || relativeOrAbsoluteUrl.startsWith('https://') || relativeOrAbsoluteUrl.startsWith('data:')) {
    return relativeOrAbsoluteUrl;
  }
  const baseUrlWithoutApi = API_BASE_URL.replace(/\/api$/, '');
  return `${baseUrlWithoutApi}${relativeOrAbsoluteUrl.startsWith('/') ? '' : '/'}${relativeOrAbsoluteUrl}`;
}

export async function apiFetch(endpoint, options = {}) {
  const token = localStorage.getItem('goodvale_token');
  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const config = {
    ...options,
    headers,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

    if (response.status === 401 && headers.Authorization === `Bearer ${localStorage.getItem('goodvale_token')}`) {
      // Session expired or unauthenticated
      localStorage.removeItem('goodvale_token');
      localStorage.removeItem('goodvale_user');
      window.dispatchEvent(new Event('goodvale-auth-change'));
    }

    if (!response.ok) {
      throw await apiErrorFromResponse(response, i18n);
    }

    // Return JSON if body exists
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return translateApiMessages(await response.json(), (key, params) => i18n.t(key, params), key => i18n.exists(key));
    }

    return null;
  } catch (error) {
    console.error(`API Error [${endpoint}]:`, error);
    if (error instanceof TypeError) { const networkError = new Error(i18n.t('api.status.network')); networkError.translationKey = 'api.status.network'; throw networkError; }
    throw error;
  }
}
